import React from 'react'
import NumberField from '../NumberField'
import Option from '../Option'

type RangeProps = {
  label: string
  min?: number
  max?: number
  value?: number
  change: (value: number) => void
}

function Range({ label, min = 0, max = 100, value = 0, change }: RangeProps) {
  function setNumberValue(event: React.ChangeEvent<HTMLInputElement>) {
    change(Number(event.target.value))
  }

  const progress = ((value - min) / (max - min)) * 100

  return (
    <Option label={label}>
      <div className="flex items-center justify-between gap-2">
        <input
          className="range-slider w-[190px]"
          style={{ '--range-progress': `${progress}%` } as React.CSSProperties}
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={setNumberValue}
        />
        <NumberField value={value} min={min} max={max} update={change} />
      </div>
    </Option>
  )
}

export default Range
